import * as React from 'react';

import { CORRECT_MATCHED, DEFAULT, DEFAULT_FILL_IN_BLANK, DEFAULT_WITH_CUES, Feedback, GET_QUESTION_INSTRUCTIONS, INSTRUCTIONS, OVERRIDE, REVISE_MATCHED, REVISE_UNMATCHED, getAnswerState, getLatestAttempt } from '../../../Shared/index';
import staticStrings from '../../../Shared/libs/speech/staticStrings.json';

class FeedbackComponent extends React.Component<any, any> {

  getFeedbackType(data?): string {
    if (data) {
      const latestAttempt = getLatestAttempt(data.question.attempts);
      if (latestAttempt) {
        if (data.override) {
          return OVERRIDE
        } else if (latestAttempt.response.feedback !== undefined) {
          const state = getAnswerState(latestAttempt);
          return state ? CORRECT_MATCHED : REVISE_MATCHED
        } else {
          return REVISE_UNMATCHED
        }
      } else {
        if(!!data.question.instructions) {
          return INSTRUCTIONS
        }
        else if(data.question && data.question.instructions!=="") {
          return GET_QUESTION_INSTRUCTIONS
        }
        else if (data.question.prompt.match(/___/g) && data.question.prompt.match(/___/g).length > 0) {
          return DEFAULT_FILL_IN_BLANK
        }
        else if (data.question && data.question.cues && data.question.cues.length > 0 && data.question.cues[0] !== "") {
          return DEFAULT_WITH_CUES
        } else {
          return DEFAULT
        }
      }
    }
    return DEFAULT
  }

  getFeedbackText(data): string | undefined {
    const { question, sentence } = data;
    let returnVal;
    switch (this.getFeedbackType(data)) {
      case REVISE_UNMATCHED:
        returnVal = sentence;
        break;
      case REVISE_MATCHED:
      case CORRECT_MATCHED:
        returnVal = undefined;
        break;
      case OVERRIDE:
        returnVal = sentence;
        break;
      case INSTRUCTIONS:
        returnVal = question.instructions;
        break;
      case GET_QUESTION_INSTRUCTIONS:
        returnVal = question.instructions || '';
        break;
      case DEFAULT_FILL_IN_BLANK:
        returnVal = staticStrings['connect.defaultFillInBlankInstructions'];
        break;
      case DEFAULT_WITH_CUES:
        const cues = question.cues
        if (cues.length === 1) {
          returnVal = staticStrings['connect.defaultInstructionsWithCue']
        } else {
          returnVal = staticStrings['connect.defaultInstructionsWithCues']
        }
        break;
      case DEFAULT:
        returnVal = staticStrings['connect.defaultInstructions']
        break;
      default:
        returnVal = staticStrings['connect.defaultInstructions']
    }
    return returnVal
  }

  getFeedbackHtml(data): string | undefined {
    const { question } = data;
    const feedbackType = this.getFeedbackType(data);
    if (feedbackType !== REVISE_MATCHED && feedbackType !== CORRECT_MATCHED) { return undefined }

    const latestAttempt = getLatestAttempt(question.attempts);
    return latestAttempt.response.feedback
  }

  render() {
    const { question, showTranslation, translate, latestAttempt, languageLocale } = this.props
    const key:number = question && question.attempts ? question.attempts.length : 0;
    if (question) {
      return (
        <Feedback
          feedbackHtml={this.getFeedbackHtml(this.props)}
          feedbackText={this.getFeedbackText(this.props)}
          feedbackType={this.getFeedbackType(this.props)}
          key={key}
          languageLocale={languageLocale}
          latestAttempt={latestAttempt}
          question={question}
          showTranslation={showTranslation}
          translate={translate}
        />
      )
    } else {
      return <span />
    }
  }
}

export default FeedbackComponent;
